/**
 * Created by Jie Gao on 2021-02-22.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TweenLite, Linear, TimelineMax} from "gsap";
import {GGGameConfig} from "../../GGGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GGSoundConfig} from "../../GGSoundConfig";

export class DoubleBombSpinIntroView extends BaseView {
    private _container:PIXI.Container;
    private _featureSplash:PIXI.Sprite;
    private _featureAnimation:PIXI.spine.Spine;
    private _layer:PIXI.Container;
    constructor() {
        super();
        this._layer = StageManager.getLayer(GGGameConfig.instance.LAYERS.FREESPIN_INTRO.name);
    }

    protected initAnimations() {
        this._container = new PIXI.Container();
        this._featureSplash = new PIXI.Sprite();
        this._featureSplash.position.set(0,0);
        this._featureSplash.anchor.set(0,0);
        const dimmer = new PIXI.Sprite(GameResources.getTextures("reelBackground")[0]);
        dimmer.anchor.set(0.5, 0.5);
        dimmer.position.set(0,46);
        this._container.addChild(dimmer);
        this._container.addChild(this._featureSplash);
        this.addChild(this._container);
    }

    public show(tl:TimelineMax):void {
        this.visible = true;
        this.alpha = 0;
        this._featureAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset("XBombX2"));
        this._featureSplash.addChild(this._featureAnimation);
        tl.add([
            () => {
                GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.FS_INTRO_XBOMB);
                this._featureAnimation.state.setAnimation(0, "FMS_Intro", false);
                this._layer.addChild(this);
            },
            TweenLite.to(this, 0, {alpha : 1})
        ], 0);
        tl.add(()=>{
                GGGameModuleConfig.fsCounter.showFlag("featureSign_x2bomb", 3, false);
            },1);
        tl.add(TweenLite.to(this, 0.4, {alpha:0, ease : Linear.easeInOut}),2.43);
    }

    public stopPresentation():void {
        this._featureSplash.removeChild(this._featureAnimation);
        this._featureAnimation.destroy();
        this.visible = false;
        this._layer.removeChild(this);
    }

    protected onResize(resizeData:IResizeData):void {
        const splashScale:number = resizeData.orientation === Orientation.PORTRAIT ? 0.9 : 0.7;
        this._container.position.set(360, 360);
        this._featureSplash.scale.set(splashScale, splashScale);
    }
}